"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var colors_1 = require("@material-ui/core/colors");
var styles_1 = require("@material-ui/core/styles");
var primaryMain = '#3D77F9';
var primaryLight = '#d3d6f1';
var textPrimary = 'rgba(100, 100, 100, 1)';
var textSecondary = 'rgba(130, 130, 130, 1)';
var body2 = {
    fontFamily: '"Rubik", sans-serif',
    fontSize: 16,
    lineHeight: 1.5,
    fontWeight: 300
};
exports.default = styles_1.createMuiTheme({
    palette: {
        primary: {
            light: primaryLight,
            main: primaryMain
        },
        secondary: {
            main: '#DDD',
            contrastText: '#FFF'
        },
        grey: {
            200: '#EFEFEF',
            500: '#696969'
        },
        text: {
            primary: textPrimary,
            secondary: textSecondary
        }
    },
    overrides: {
        MuiButton: {
            root: {
                borderRadius: 10,
                letterSpacing: '1px',
                fontWeight: 300
            },
            outlined: {
                borderWidth: 2,
                padding: '5px 16px',
                fontWeight: 400
            },
            outlinedPrimary: {
                backgroundColor: 'rgba(61,119,249, .15)',
                borderColor: 'rgba(61,119,249, .5)'
            }
        },
        MuiSvgIcon: {
            root: {
                fontSize: '1.5rem'
            }
        },
        MuiAvatar: {
            root: {
                fontSize: '1rem'
            }
        },
        MuiInput: {
            input: {
                padding: '0'
            },
            underline: {
                '&::before': {
                    borderWidth: '0 0 2px'
                }
            }
        },
        MuiLink: {
            root: {
                'color': colors_1.grey[500],
                'textDecoration': 'none',
                '&:hover': {
                    color: primaryMain,
                    textDecoration: 'none'
                }
            }
        },
        MuiCard: {
            root: {
                borderRadius: 5,
                boxShadow: '0 0 5px rgba(0,0,0,.1)'
            }
        },
        MuiInputBase: {
            input: __assign(__assign({}, body2), { color: textPrimary })
        },
        MuiInputLabel: {
            root: __assign(__assign({}, body2), { color: textSecondary })
        },
        MuiFilledInput: {
            input: {
                borderRadius: '6px 6px 0 0',
                backgroundColor: primaryLight
            },
            underline: {
                '&::before': {
                    borderWidth: 2,
                    borderColor: primaryMain
                },
                '&:hover': {
                    '&::before': {
                        borderWidth: 2
                    }
                }
            },
            root: {
                fontSize: 14
            }
        },
        MuiFormControl: {
            marginDense: {
                marginTop: 0,
                marginBottom: 0
            }
        }
    },
    spacing: 8,
    typography: {
        subtitle1: {
            fontFamily: '"Rubik", sans-serif',
            fontSize: 14,
            letterSpacing: '0.1em',
            fontStyle: 'normal',
            fontWeight: 300
        },
        subtitle2: {
            fontFamily: '"Rubik", sans-serif',
            fontSize: 12,
            letterSpacing: '0.02em',
            fontWeight: 300
        },
        body1: {
            fontFamily: '"Rubik", sans-serif',
            fontSize: 18,
            lineHeight: 1.5
        },
        body2: body2,
        h1: {
            fontFamily: '"Sofia-Pro", sans-serif',
            fontSize: 72,
            fontWeight: 600,
            lineHeight: 1.2
        },
        h2: {
            fontFamily: '"Sofia-Pro", sans-serif',
            fontSize: 60,
            fontWeight: 300,
            lineHeight: 1.2
        },
        h3: {
            fontFamily: '"Sofia-Pro", sans-serif',
            fontSize: 48,
            fontWeight: 600,
            lineHeight: 1.2
        },
        h4: {
            fontFamily: '"Sofia-Pro", sans-serif',
            fontSize: 30,
            fontWeight: 600,
            lineHeight: 1.2
        },
        h5: {
            fontFamily: '"Sofia-Pro", sans-serif',
            fontSize: 24,
            fontWeight: 600,
            lineHeight: 1.2
        },
        h6: {
            fontFamily: '"Sofia-Pro", sans-serif',
            fontSize: 15,
            fontWeight: 600,
            lineHeight: 1.2,
            letterSpacing: -0.5
        },
        caption: {
            fontFamily: '"Rubik", sans-serif',
            fontWeight: 400,
            fontSize: 11,
            lineHeight: 1.28
        }
    }
});
